import axios from 'axios';

axios.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);

// 设置环境 "http://localhost:9005" 测试环境106.52.40.63
var dev = "http://192.168.124.166:9007";
var test = "https://www.ioofox.com:9007";
var pro = "https://halababyapp.halababy.com:9007";
export var sip = pro;
export function spost(urlPath, params = {}) {
    let url = sip + urlPath;
    let obj = new FormData();
    for (let key in params) {
        obj.append(key, params[key]);
    }
    return new Promise((resolve, reject) => {
        axios.post(url, obj)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}


// WEBPACK FOOTER //
// ./src/utils/httpSpreader.js